import { useMediaQuery } from '@vueuse/core';

/** max-width: 30rem - 480px */
export const screenXs = useMediaQuery('(max-width: 30rem)');

/** min-width: 30rem - 480px */
export const screenMinXs = useMediaQuery('(min-width: 30rem)');

/** min-width: 40rem - 640px */
export const screenMinSm = useMediaQuery('(min-width: 40rem)');

/** max-width: 40rem - 640px: the `mobile` SCSS mixin's edge, so a template and its styles switch together */
export const screenMobile = useMediaQuery('(max-width: 40rem)');

/** min-width: 48rem - 768px */
export const screenMinMd = useMediaQuery('(min-width: 48rem)');

/** min-width: 64rem - 1024px */
export const screenMinLg = useMediaQuery('(min-width: 64rem)');

/** min-width: 80rem - 1280px */
export const screenMinXl = useMediaQuery('(min-width: 80rem)');

/** min-width: 96rem - 1536px */
export const screenMinXxl = useMediaQuery('(min-width: 96rem)');

/** min-width: 120rem - 1920px */
export const screenMinXxxl = useMediaQuery('(min-width: 120rem)');
